import { render, staticRenderFns } from "./MessageItemLinkFeedView.vue?vue&type=template&id=72e9bff0&scoped=true&"
import script from "./MessageItemLinkFeedView.vue?vue&type=script&lang=ts&"
export * from "./MessageItemLinkFeedView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItemLinkFeedView.vue?vue&type=style&index=0&id=72e9bff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9bff0",
  null
  
)

export default component.exports